import React from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  animation?: 'fade-up' | 'fade-in' | 'slide-left' | 'slide-right';
}

const AnimatedSection: React.FC<AnimatedSectionProps> = ({ 
  children, 
  className = '', 
  animation = 'fade-up' 
}) => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1, once: true });

  const animationClasses = {
    'fade-up': 'transition-all duration-700 ease-out',
    'fade-in': 'transition-opacity duration-700 ease-out',
    'slide-left': 'transition-all duration-700 ease-out',
    'slide-right': 'transition-all duration-700 ease-out',
  };

  const initialState = {
    'fade-up': 'opacity-0 translate-y-8',
    'fade-in': 'opacity-0',
    'slide-left': 'opacity-0 -translate-x-8',
    'slide-right': 'opacity-0 translate-x-8',
  };

  const visibleState = {
    'fade-up': 'opacity-100 translate-y-0',
    'fade-in': 'opacity-100',
    'slide-left': 'opacity-100 translate-x-0',
    'slide-right': 'opacity-100 translate-x-0',
  };

  return (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      className={`${animationClasses[animation]} ${
        isVisible ? visibleState[animation] : initialState[animation]
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default AnimatedSection;
